import { noop } from '@vkontakte/vkjs';
import { createContext } from 'react';
import { CardResolveDirection } from './types';

export type CardSwipesTransformListener = (details: { shift: number; shiftRatio: number }) => void;

export type CardSwipesDirectionListener = (details: { direction: CardResolveDirection | null }) => void;

export interface CardSwipesContext {
  addTransformAnimationFrameListener: (listener: CardSwipesTransformListener) => void;
  removeTransformAnimationFrameListener: (listener: CardSwipesTransformListener) => void;
  addDirectionListener: (direction: CardSwipesDirectionListener) => void;
  removeDirectionListener: (direction: CardSwipesDirectionListener) => void;
}

export const cardSwipesContext = createContext<CardSwipesContext>({
  addTransformAnimationFrameListener: noop,
  removeTransformAnimationFrameListener: noop,
  addDirectionListener: noop,
  removeDirectionListener: noop,
});
